import { Map } from 'immutable';

import { ApiResponseHelper } from 'omni-common-ui';

import {
  APPROVE_STUDENT_REPORT_REQUEST,
  APPROVE_STUDENT_REPORT_SUCCESS,
  APPROVE_STUDENT_REPORT_FAILURE,
} from './actions';

export default function approveByDos(state = new Map(), action) {
  const key = `${action.progressReportId}-${action.studentReportId}`;
  switch (action.type) {
    case APPROVE_STUDENT_REPORT_REQUEST:
      return state.set(key, ApiResponseHelper.create({ loading: true }));
    case APPROVE_STUDENT_REPORT_SUCCESS:
      return state.set(key, ApiResponseHelper.create({ data: true }));
    case APPROVE_STUDENT_REPORT_FAILURE:
      return state.set(key, ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/ProgressReports/ApproveByDos/reducer.js